// AdminPanel.js — Merge Solponiente + SectorBXII
import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Nav,
  Navbar,
  Card,
  Button,
  Accordion,
} from "react-bootstrap";
import logo from "../Images/regantesolponienteportada.jpeg";
import "bootstrap/dist/css/bootstrap.min.css";
import FormularioPublicaciones from "./FormularioPublicaciones";
import TablaSolicitudes from "./TablaSolicitudes";
import BuscadorDocumentos from "./BuscadorDocumentos";
import FormularioNotificaciones from "./FormularioNotificaciones";
import Usuarios from "./Usuario";
import Footer from "../Components/Footer";

const navLinks = [
  { key: "home",           icon: "bi-house",         label: "Inicio" },
  { key: "notificaciones", icon: "bi-bell",           label: "Notificaciones" },
  { key: "solicitudes",    icon: "bi-file-earmark",   label: "Solicitudes" },
  { key: "documentos",     icon: "bi-search",         label: "Documentos" },
  { key: "publicaciones",  icon: "bi-megaphone",      label: "Publicaciones" },
  { key: "usuarios",       icon: "bi-people",         label: "Usuarios" },
];

const AdminHome = () => {
  const [activeSection, setActiveSection] = useState("home");

  const navigate = (section) => setActiveSection(section);

  const renderContent = () => {
    switch (activeSection) {
      case "home":
        return (
          <Row className="p-2">
            {[
              {
                key: "notificaciones",
                icon: "bi-bell",
                title: "Notificaciones",
                text: "Cree y envíe notificaciones a los usuarios. Gestione el histórico de notificaciones enviadas.",
                btn: "Ir a Notificaciones",
              },
              {
                key: "solicitudes",
                icon: "bi-file-earmark-text",
                title: "Solicitudes",
                text: "Revise y gestione las solicitudes enviadas por los usuarios.",
                btn: "Ver Solicitudes",
              },
              {
                key: "documentos",
                icon: "bi-search",
                title: "Documentos",
                text: "Busque documentos de un usuario específico en el sistema.",
                btn: "Buscar Documentos",
              },
              {
                key: "publicaciones",
                icon: "bi-megaphone",
                title: "Publicaciones",
                text: "Cree publicaciones en el tablón de anuncios.",
                btn: "Crear Publicación",
              },
              {
                key: "usuarios",
                icon: "bi-people",
                title: "Usuarios",
                text: "Consulte y gestione los usuarios registrados en la plataforma.",
                btn: "Gestionar Usuarios",
              },
            ].map((item) => (
              <Col md={6} key={item.key} className="mb-4">
                <Card className="shadow-sm h-100">
                  <Card.Body>
                    <Card.Title>
                      <i className={`bi ${item.icon} me-2 text-primary`}></i>
                      <strong>{item.title}</strong>
                    </Card.Title>
                    <Card.Text>{item.text}</Card.Text>
                    <Button variant="primary" onClick={() => navigate(item.key)}>
                      {item.btn}
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        );

      case "notificaciones":
        return (
          <Card className="shadow-sm border-0" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title className="mb-3">
                <i className="bi bi-bell me-2 text-primary"></i>
                <strong>Formulario de Notificaciones</strong>
              </Card.Title>
              <p className="text-muted">
                Seleccione un usuario y envíe una notificación personalizada o
                consulte el histórico.
              </p>
              <FormularioNotificaciones />
            </Card.Body>
          </Card>
        );

      case "solicitudes":
        return (
          <Card className="shadow-sm border-0" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title className="mb-3">
                <i className="bi bi-file-earmark-text me-2 text-primary"></i>
                <strong>Gestión de Solicitudes</strong>
              </Card.Title>
              <TablaSolicitudes />
            </Card.Body>
          </Card>
        );

      case "documentos":
        return (
          <Card className="shadow-sm border-0" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title className="mb-3">
                <i className="bi bi-search me-2 text-primary"></i>
                <strong>Búsqueda de Documentos</strong>
              </Card.Title>
              <p className="text-muted">Seleccione un usuario para buscar sus documentos.</p>
              <BuscadorDocumentos />
            </Card.Body>
          </Card>
        );

      case "publicaciones":
        return (
          <Card className="shadow-sm border-0" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title className="mb-3">
                <i className="bi bi-megaphone me-2 text-primary"></i>
                <strong>Formulario de Publicaciones</strong>
              </Card.Title>
              <p className="text-muted">Cree un nuevo anuncio para el tablón de anuncios.</p>
              <FormularioPublicaciones />
            </Card.Body>
          </Card>
        );

      case "usuarios":
        return <Usuarios />;

      default:
        return <h3>Bienvenido al Panel de Administración</h3>;
    }
  };

  const SidebarLinks = () => (
    <Nav className="flex-column w-100">
      {navLinks.map((link) => (
        <Nav.Link
          key={link.key}
          className={activeSection === link.key ? "active" : ""}
          onClick={() => navigate(link.key)}
        >
          <i className={`bi ${link.icon} me-2`}></i>
          {link.label}
        </Nav.Link>
      ))}
      <Nav.Link
        className="text-danger"
        onClick={() => {
          localStorage.removeItem("token");
          window.location.href = "/login";
        }}
      >
        <i className="bi bi-box-arrow-right me-2"></i> Cerrar sesión
      </Nav.Link>
    </Nav>
  );

  return (
    <Container fluid>
      <Row className="min-vh-100">
        {/* Sidebar desktop */}
        <Col xs={12} md={3} lg={2} className="sidebar bg-light">
          <Navbar className="flex-column pt-3 d-none d-md-flex">
            <Navbar.Brand className="mb-4">
              <img
                src={logo}
                alt="Logo Solponiente"
                style={{ width: "250px", objectFit: "contain" }}
              />
            </Navbar.Brand>
            <div className="small text-muted mb-3 px-2 fw-semibold text-uppercase">
              Panel de Administración
            </div>
            <SidebarLinks />
          </Navbar>

          {/* Menú móvil */}
          <Col className="text-primary mt-4 mb-2 text-center d-md-none">
            <h5>Panel de Administración</h5>
          </Col>
          <Accordion className="d-block d-md-none mb-3">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <strong className="text-primary">Menú</strong>
              </Accordion.Header>
              <Accordion.Body className="p-0">
                <SidebarLinks />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        {/* Contenido principal */}
        <Col xs={12} md={9} lg={10} className="p-4">
          {renderContent()}
        </Col>

        <Footer />
      </Row>
    </Container>
  );
};

export default AdminHome;
